export const PROVISIONED_UI_FLAGS = Object.freeze({
    UI_ALL_TEAM_WORKSPACES_PHASE_1: 'UI_ALL_TEAM_WORKSPACES_PHASE_1',
    RELEASE_TEAM_WORKSPACE_SPEND_FE: 'RELEASE_TEAM_WORKSPACE_SPEND_FE',
})
